module.exports = __webpack_public_path__ + "static/media/parking.1eec9e69.svg";